import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, themeMode, zIndex, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import Level from '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { DropdownMenu } from '../DropdownMenu/DropdownMenu.es.js';
import { Checkbox } from '../Checkbox/Checkbox.es.js';
var Item = styled(DropdownMenu.Item).withConfig({
  componentId: "sc-1shbfpx-0"
})(["padding-left:", ";padding-right:", ";"], spacing("xs"), spacing("xs"));
var Footer = styled(Level).withConfig({
  componentId: "sc-1shbfpx-1"
})(["padding:0 ", ";bottom:0px;overflow:hidden;height:52px;margin-bottom:-", ";"], spacing("sm"), spacing("xxs"));
var Header = styled(Box).withConfig({
  componentId: "sc-1shbfpx-2"
})(["position:sticky;top:0;padding-top:", ";background-color:", ";z-index:", ";"], spacing("xxs"), themeMode({
  light: palette("neutral.0"),
  dark: palette("neutral.800")
}), zIndex("overlay"));
var FilterDropdownCheckbox = styled(Checkbox).withConfig({
  componentId: "sc-1shbfpx-3"
})(["pointer-events:none;"]);
export { FilterDropdownCheckbox, Footer, Header, Item };